module.exports = __webpack_public_path__ + "static/assets/8a75b7b5736a8eea9880a015c13ae866.svg";